// removed by extract-text-webpack-plugin
module.exports = {"btn":"_1Uw8CVVQMCmPn4amRolA1E","xs":"_3j_KiNDqbL-6JFGWEuSnIM","disabled":"_2jI9HjKstAXkYiJIkTaDtb","inline":"_1fQeo2DIZVwwQd3ffPoSSM","primary":"_1sowNhRIq3kzqiL-Emk9mJ","secondary":"_3sfusfRDgyx1si6t8Eg5Cf","secondary-light":"_3DAZgSZTlpdFxNmr19VfDf","light":"_3zvfn_VJADl56-JdEmYfZt","dark":"Jdws-PuOJzKcKO1LxdCSz","styled-tag":"_2l1vUxkHwE53MRJHoVTPQ4"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Button/style.css
// module id = 421
// module chunks = 38